<script setup>
definePage({ meta: { ...PageMeta.Messages.Add.Meta, pageTitle: PageMeta.Messages.Add.Title } })
</script>

<template>
  <div />
</template>
